import { CredentialWithId } from "../types/credentialTypes";

interface CredentialsListProps {
  credentials: CredentialWithId[];
  selectedCredentialId: string | null;
  onCredentialSelect: (credential: CredentialWithId) => void;
}

export const CredentialsList = ({
  credentials,
  selectedCredentialId,
  onCredentialSelect,
}: CredentialsListProps) => {
  return (
    <div className="flex w-1/2 flex-col">
      <div className="mb-2 font-semibold">Portal Name</div>
      <div className="flex flex-col gap-4 overflow-auto p-1">
        {credentials && credentials.length > 0 ? (
          credentials.map((credential: CredentialWithId) => (
            <div
              key={credential?.id}
              className={`flex h-14 w-full cursor-pointer flex-col justify-center rounded-lg border border-primaryGray-14 p-3 font-semibold hover:bg-gray-50 ${
                selectedCredentialId === credential?.id
                  ? "border-primaryGray-11 shadow-lg"
                  : ""
              }`}
              onClick={() => onCredentialSelect(credential)}
            >
              {credential?.portal_name}
            </div>
          ))
        ) : (
          <div className="flex h-full items-center justify-center text-gray-500">
            No Portals found for this client
          </div>
        )}
      </div>
    </div>
  );
};
